import * as types from '@/store/mutationTypes';

export const mutations = {
    [types.ADD_NOTIFICATION] (state, notification) {
        state.notifications.push(notification);
    },

    [types.REMOVE_NOTIFICATION] (state, id) {
        const index = state.notifications.findIndex(notification => notification.id === id);
        if (index > -1) {
            state.notifications.splice(index, 1);
        }
    },

    [types.CLEAR_NOTIFICATIONS] (state) {
        state.notifications = [];
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/notifications/mutations.js